import { render, staticRenderFns } from "./explainHome.vue?vue&type=template&id=0da0aa76&scoped=true"
import script from "./explainHome.vue?vue&type=script&lang=js"
export * from "./explainHome.vue?vue&type=script&lang=js"
import style0 from "./explainHome.vue?vue&type=style&index=0&id=0da0aa76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0aa76",
  null
  
)

export default component.exports